import { render, staticRenderFns } from "./CardSliderChild.vue?vue&type=template&id=a8fe09e2&"
import script from "./CardSliderChild.vue?vue&type=script&lang=js&"
export * from "./CardSliderChild.vue?vue&type=script&lang=js&"
import style0 from "./CardSliderChild.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
